import service from "@/store/services/signatures-service";

export const state = () => ({
  list: {},
  signature: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, signature) => {
    state.signature = signature;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((signature) => {
      commit("SET_RESOURCE", signature);
    });
  },
  
  getSignedDocuments({ commit, dispatch }, params) {
    return service.getSignedDocuments(params, this.$axios).then((signature) => {
      commit("SET_RESOURCE", signature);
    });
  },

  
  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((signature) => {
      commit("SET_RESOURCE", signature);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((signature) => {
      commit("SET_RESOURCE", signature);
    });
  },

  send({ commit, dispatch }, params) {
    return service.send(params, this.$axios).then((signature) => {
      commit("SET_RESOURCE", signature);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  signature: (state) => state.signature,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((signature) => ({
      id: signature.id,
      name: `${signature.contract.name}`,
    }));
  },
};

const signatures = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default signatures;
